import React, { createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';
import { scrollToTop } from '../components/common/scrollToTop';

export const FreightContextB2B = createContext();

const initialFilters = {
    searchBy: 'awb_no',
    searchValue: '',
    merchant_id: [],
    courier_id: [],
    dateRange: {
        startDate: new Date(),
        endDate: new Date()
    }
};
const tabOptions = [
    { label: "Today Uploads", value: 1 },
    { label: "Manifest", value: 2 },
    { label: "NDR", value: 4 },
    { label: "In Transit", value: 5 },
    { label: "Delivered", value: 8 },
    { label: "OFD", value: 7 },
    { label: "Returned to Seller", value: 12 },
    { label: "Booking Failed", value: 0 },
    { label: "All Shipped Orders", value: 99 }
];
export const FreightContextB2BProvider = ({ children }) => {
    const { user, setAlertMessage, setOpenAlert, setSeverity, globalSearch } = useContext(CommonContext);
    const navigate = useNavigate();

    const [filters, setFilters] = useState(initialFilters);
    const [activeTab, setActiveTab] = useState(tabOptions[0].value);
    const [addModal, setAddModal] = useState(false);
    const [osId, setOsId] = useState(1);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allFreight, setAllFreight] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [details, setDetails] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [reFreightModal, setReFreightModal] = useState(false);


    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };
    const openReFreightModal = () => {
        setReFreightModal(true);
    };
    const closeReFreightModal = () => {
        setReFreightModal(false);
    }


    const handleToggleDrawer = () => {
        setIsOpen(!isOpen);
    };
    // console.log('filters', filters);
    const onLoadApi = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };

        if (globalSearch?.value) {
            payload.searchBy = 'awb_no';
            payload.searchValue = globalSearch?.value;
            payload.start_date = '';
            payload.end_date = '';
            setFilters((prev) => ({ ...prev, searchBy: 'awb_no', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
        }

        delete payload.dateRange;
        setAllData([]);
        setAllFreight([]);
        setFirstLoading(false);
        commonApi.post(`/freight/list-b2b?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllFreight(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onFreightReCalculate = () => {
        setIsLoading(true);
        commonApi.post('/freight/re-calculation', { order_ids: selected, service_type: 2 })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setOpenAlert(true);
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                    setOpenAlert(true);
                    scrollToTop();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error');
                setOpenAlert(true);
                scrollToTop();
            });
    }
    const viewDetail = (id) => {
        setDetails(null);
        setIsLoading(true);
        commonApi.post('/freight/view-b2b', { id: id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setDetails(response?.data?.data);
                    handleToggleDrawer();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    }

    const onExportFreight = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = user?.id
        }
        delete payload.dateRange;
        setIsLoading(true);
        console.log('export payload', payload);
        commonApi.post('/freight/export-b2b', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.message || 'Something went wrong');
                setSeverity('error')
            });
    };
    const onMove = () => {
        setIsLoading(true);
        commonApi.post('freight/moveto-b2c', { order_ids: selected, service_type: 1 })
            .then((res) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (res?.data?.s === 1) {
                    setAlertMessage(res?.data?.msg);
                    setSeverity('success');
                } else {
                    // setResErrors(res?.data?.msg);
                }
            }).catch((err) => {
                // setResErrors(err?.response?.data?.msg || err?.message);
                setOpenAlert(true);
                setAlertMessage(err?.message);
                setSeverity('error');
                setIsLoading(false);
            });
    };
    useEffect(() => {
        if (globalSearch.searchTrigger > 0) {
            onLoadApi();
            // Reset search flag after handling
            // You might want to reset this in context or here
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalSearch.searchTrigger]);
    // Fetch initial data when the context is created
    useEffect(() => {
        onLoadApi();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab]);


    const contextValue = {
        onMove,
        onExportFreight,
        openReFreightModal,
        closeReFreightModal,
        reFreightModal,
        addModal,
        handleAddModal,
        handleCloseModal,
        onFreightReCalculate,
        isOpen,
        setIsOpen,
        handleToggleDrawer,
        viewDetail,
        details,
        initialFilters,
        osId,
        setOsId,
        allData,
        setAllData,
        allFreight,
        setAllFreight,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
    };
    return (
        <FreightContextB2B.Provider value={contextValue}>
            {children}
        </FreightContextB2B.Provider>
    );
};

